import React from 'react';
import {useParams} from 'react-router-dom';

import {useGetCandidateJobDetailsQuery} from '../api/candidate';
import {useGetUserDetailsQuery} from '../api/auth';
import UserDetails from '../components/UserDetails';

/** this component conditional handle profile of candidate and employer */

const UserLayout = (WrapperComponent) => {
  return function _InnerComponent(props) {
    const {userId = null, jobId = null} = useParams();

    const {data: candidateJobDetails, isFetching: isCandidateJobLoading} =
      useGetCandidateJobDetailsQuery(jobId);

    const {data: userDetails, isFetching: isUserDetailsLoading} =
      useGetUserDetailsQuery(userId);

    const updatedCandidateJobDetails = candidateJobDetails?.data?.candidate && {
      ...candidateJobDetails?.data?.candidate,
      ...candidateJobDetails?.data?.candidate.employee,
    };

    return (
      <div className="w-full flex min-h-screen">
        <div className="w-[700px] border-r">
          <UserDetails
            isEmployer={!!userId}
            isCandidate={!!jobId}
            userDetails={updatedCandidateJobDetails || userDetails?.data}
            loading={isCandidateJobLoading || isUserDetailsLoading}
          />
        </div>
        <div>
          <WrapperComponent {...props} />
        </div>
      </div>
    );
  };
};

export default UserLayout;
